var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailers(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "33px",
    viewBox: "0 0 98 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trailers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-555.000000, -864.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(555.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98,3.7756315 C98,1.71619614 96.3171717,0 94.1888889,0 L3.76161616,0 C1.68282828,0 0,1.71619614 0,3.7756315 L0,46.6315007 C0,48.6909361 1.68282828,50.4071322 3.81111111,50.4071322 L5.88989899,50.4071322 L5.88989899,54.4279346 C5.88989899,56.48737 7.57272727,58.2035661 9.7010101,58.2035661 L13.9575758,58.2035661 C14.7989899,62.6166419 18.7585859,66 23.4606061,66 C26.6777778,66 29.5484848,64.4309064 31.330303,62.0282318 C33.1121212,64.4309064 35.9828283,66 39.2,66 C43.9020202,66 47.8616162,62.6656761 48.7030303,58.2035661 L98,58.2035661 L98,3.7756315 Z",
    fill: "#241A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9055118,55 L10.1653543,55 C10.1102362,55 10,54.9529412 10,54.8588235 L10,51 L17,51 C16.007874,52.1764706 15.2362205,53.5411765 14.9055118,55 Z",
    fill: "#DEC330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,62 C20.704918,62 18,59.295082 18,56 C18,52.704918 20.6557377,50.0491803 23.9508197,50 L24.0491803,50 C27.3442623,50 30,52.704918 30,56 C29.9508197,59.3442623 27.295082,62 24,62 Z",
    fill: "#818486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,62 C35.704918,62 33,59.295082 33,56 C33,52.704918 35.6557377,50.0491803 38.9508197,50 L39.0491803,50 C42.3442623,50 45,52.704918 45,56 C45,59.3442623 42.295082,62 39,62 Z",
    fill: "#818486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,55 L48.1122004,55 C47.8213508,53.4768786 47.1427015,52.0520231 46.2216776,50.8236994 L81.1236383,50.8236994 C82.1416122,50.8236994 82.9172113,49.9884393 82.9172113,49.0057803 C82.9172113,48.0231214 82.0931373,47.1878613 81.1236383,47.1878613 L4.14542484,47.1878613 C4.09694989,47.1878613 4,47.1387283 4,47.0404624 L4,4.14739884 C4,4.0982659 4.04847495,4 4.14542484,4 L92.7091503,4 C92.7576253,4 92.8545752,4.04913295 92.8545752,4.14739884 L92.8545752,47.1878613 L88.8796296,47.1878613 C87.8616558,47.1878613 87.0860566,48.0231214 87.0860566,49.0057803 C87.0860566,50.0375723 87.9101307,50.8236994 88.8796296,50.8236994 L92.9515251,50.8236994 L93,55 Z",
    fill: "#DEC330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1967509,39 L9.8032491,39 C8.77978339,39 8,39.9189189 8,41 C8,42.0810811 8.82851986,43 9.8032491,43 L87.1967509,43 C88.2202166,43 89,42.0810811 89,41 C89,39.8648649 88.2202166,39 87.1967509,39 Z",
    fill: "#241A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,54 L24,54 C22.8648649,54 22,54.9189189 22,56 C22,57.1351351 22.9189189,58 24,58 C25.0810811,58 26,57.0810811 26,56 C26,54.9189189 25.0810811,54 24,54 Z",
    fill: "#241A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,54 L39,54 C37.8648649,54 37,54.9189189 37,56 C37,57.1351351 37.9189189,58 39,58 C40.0810811,58 41,57.0810811 41,56 C41,54.9189189 40.0810811,54 39,54 Z",
    fill: "#241A2E"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailers);
export default __webpack_public_path__ + "static/media/Trailers.4691a33bc8b571f93a6167522cf3fd36.svg";
export { ForwardRef as ReactComponent };